import { render } from "./SearchArtist.vue?vue&type=template&id=7fec70dc"
import script from "./SearchArtist.vue?vue&type=script&lang=js"
export * from "./SearchArtist.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/XAMPP/xamppfiles/htdocs/studioemme/wp-content/themes/studioemme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__